import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { Link } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react/dist/iconify.js";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("ACTIVE");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false); // Loading state
  const getUsersMasterAdmin = async () => {
    setLoading(true); // Start loading
    try {
      let body = { user_status: activeTab };
      let response = await axios.post(
        `${BaseUrl}/get-users-master-admin`,
        body
      );
      if (response.status === 200) {
        setUsers(response.data.data);
        setFilteredUsers(response.data.data);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
      
    }
    finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    setCurrentPage(1); // Reset to first page on tab change
    getUsersMasterAdmin();
  }, [activeTab]);

  // Handle search functionality
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(
        (user) =>
          user.fullname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.mobilenumber?.includes(searchTerm)
      );
      setFilteredUsers(filtered);
    }
    setCurrentPage(1); // Reset to first page on search
  }, [searchTerm, users]);

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="User Management" />
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header py-16 pb-0 px-24 bg-base border border-end-0 border-start-0 border-top-0 d-flex align-items-center flex-wrap justify-content-between">
              <div className="search-container position-relative">
                <input
                  type="text"
                  className="form-control ps-4 pe-5"
                  placeholder="Search by name, email or mobile..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ minWidth: "300px" }}
                />
                <Icon icon="solar:magnifer-linear" className="position-absolute" style={{ right: "15px", top: "50%", transform: "translateY(-50%)", color: "#6c757d" }} />
              </div>
              <ul
                className="nav bordered-tab d-inline-flex nav-pills mb-0"
                id="pills-tab-six"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link px-16 py-10 ${activeTab === "ACTIVE" ? "active" : ""
                      }`}
                    type="button"
                    onClick={() => setActiveTab("ACTIVE")}
                  >
                    Active
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link px-16 py-10 ${activeTab === "SUSPEND" ? "active" : ""
                      }`}
                    type="button"
                    onClick={() => setActiveTab("SUSPEND")}
                  >
                    Suspend
                  </button>
                </li>
              </ul>
            </div>

            <div className="card-body">
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    minHeight: "calc(100vh - 300px)",
                    width: "100%",
                    background: "transparent",
                  }}
                >
                  <div
                    className="spinner-border"
                    role="status"
                    style={{
                      color: "#243E85",
                      width: "3rem",
                      height: "3rem",
                    }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : paginatedUsers.length === 0 ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    minHeight: "200px",
                    width: "100%",
                    fontSize: "1.2rem",
                    color: "#243E85",
                    fontWeight: 500,
                  }}
                >
                  No users found.
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table basic-border-table mb-0">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Mobile Number</th>
                          <th>Sign In Type</th>
                          {/* <th>Status</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedUsers?.map((items, index) => (
                          <tr key={index}>
                            <td>{formatDate(items?.createdAt)}</td>
                            <td>{items?.fullname || "-"}</td>
                            <td>{items?.email}</td>
                            <td>
                              {items.mobilenumber
                                ? items.country_code + " " + items.mobilenumber
                                : "-"}
                            </td>
                            <td>
                              {items.signup_type === "GOOGLE" ? (
                                <span className="bg-warning-focus text-warning-main px-32 py-4 rounded-pill fw-medium text-sm">
                                  GOOGLE
                                </span>
                              ) : (
                                <span className="bg-success-focus text-success-main px-32 py-4 rounded-pill fw-medium text-sm">
                                  NORMAL
                                </span>
                              )}
                            </td>
                            {/* <td>
                              {items.user_status === "ACTIVE" ? (
                                <span className="bg-success-focus text-success-main px-32 py-4 rounded-pill fw-medium text-sm">
                                  Active
                                </span>
                              ) : items.user_status === "SUSPEND" ? (
                                <span className="bg-danger-focus text-danger-main px-32 py-4 rounded-pill fw-medium text-sm">
                                  Suspended
                                </span>
                              ) : null}
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination controls */}
                  {filteredUsers.length > itemsPerPage && (
                    <div className="mt-4 d-flex justify-content-between align-items-center">
                      <span>
                        Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                        {Math.min(currentPage * itemsPerPage, filteredUsers.length)} of{" "}
                        {filteredUsers.length} users
                      </span>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1 || filteredUsers.length === 0}
                        >
                          Prev
                        </button>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() =>
                            setCurrentPage((prev) =>
                              prev < Math.ceil(filteredUsers.length / itemsPerPage)
                                ? prev + 1
                                : prev
                            )
                          }
                          disabled={
                            currentPage === Math.ceil(filteredUsers.length / itemsPerPage) || filteredUsers.length === 0
                          }
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default UserManagement;
